import { ReactElement, ReactNode } from 'react';
import { toast as sonnerToast } from 'sonner';
import Alert, { Severity } from './components/Alert';

const BOTTOM_OFFSET = 52;

type ToastParams =
  | string
  | {
      id?: string;
      message: ReactNode;
      icon?: ReactElement;
      withSound?: boolean;
      title?: ReactNode;
      action?: ReactNode;
      dismissible?: boolean;
      duration?: number;
      onDismiss?: () => void;
    };

type Toast = {
  success: (params: ToastParams) => void;
  error: (params: ToastParams) => void;
  warning: (params: ToastParams) => void;
  info: (params: ToastParams) => void;
};

const toast: Toast = {
  success: (params) => generateToast('success', params),
  error: (params) => generateToast('error', params),
  warning: (params) => generateToast('warning', params),
  info: (params) => generateToast('info', params),
};

const generateToast = (severity: Severity, params: ToastParams) => {
  const message = typeof params === 'string' ? params : params.message;

  return typeof params === 'string'
    ? sonnerToast.custom((sonnerId) => <Alert id={sonnerId} severity={severity} content={message} />, {
        style: { bottom: BOTTOM_OFFSET },
      })
    : sonnerToast.custom(
        (sonnerId) => <Alert id={params.id || sonnerId} severity={severity} content={message} {...params} />,
        {
          // Only pass id if it's provided, otherwise let sonner use its own
          ...(params.id ? { id: params.id } : {}),
          duration: params.duration,
          onDismiss: params.onDismiss,
          style: { bottom: BOTTOM_OFFSET },
        }
      );
};

export default toast;
